import React from 'react';
import SecondaryButton from '../../button/SecondaryButton';
import './TabNav.css';

/**
 * TabNav Component
 * Tab navigation component using Button sub-components
 * 
 * @param {Array} tabs - Array of tab objects {id: string, label: string, count?: number}
 * @param {string} activeTab - Currently active tab ID
 * @param {function} onTabChange - Callback when tab changes: (tabId: string) => void
 * @param {string} className - Additional CSS classes
 */
const TabNav = ({
  tabs = [],
  activeTab,
  onTabChange,
  className = ''
}) => {
  const handleTabClick = (tabId) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <nav className={`tab-nav ${className}`.trim()}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        
        return (
          <SecondaryButton
            key={tab.id}
            variant="outline"
            size="small"
            onClick={() => handleTabClick(tab.id)}
            className={`tab-button ${isActive ? 'active' : ''}`.trim()}
          >
            <span className="tab-label">{tab.label}</span>
            {tab.count !== undefined && tab.count !== null && (
              <span className={`tab-count ${isActive ? 'active' : ''}`.trim()}>
                {tab.count}
              </span>
            )}
          </SecondaryButton>
        );
      })}
    </nav>
  );
};

export default TabNav;

